<template>
    <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        :header-cell-style="headCellStyle" :cell-style="bodyCellStyle" :height="tableHeight"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column :label="$t('user.account')" show-overflow-tooltip prop="account">
            <template #default="{ row }">
                <span>
                    {{ row.account }}
                </span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_scope')" v-if="activeUserType !== 'PERSONAL' && ($store.state.type === 3 || $store.state.type === 2)"
            show-overflow-tooltip prop="scopeName" />
        <el-table-column :label="$t('user.name')" show-overflow-tooltip prop="username" />
        <!-- Status 列：使用 icon 显示 -->
        <el-table-column :label="$t('user.status')" prop="status" width="100px">
            <template #default="{ row }">
                <el-tooltip :content="getStatusLabel(row.status)" placement="top">
                    <i :class="getStatusIcon(row.status).icon" :style="{ color: getStatusIcon(row.status).color, fontSize: '16px' }"></i>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column :label="$t('account_redesign.mobile_phone')" show-overflow-tooltip prop="mobile" />
        <el-table-column :label="$t('public.email')" show-overflow-tooltip prop="email" />
        <el-table-column :label="$t('public.table_operation')" prop="operate" width="120px">
            <template #default="{ row }">
                <el-button type="text" icon="el-icon-refresh" size="small" :title="$t('account_redesign.reinvite')"
                    @click="againFn(row)"> </el-button>
                <el-button type="text" icon="el-icon-edit" size="small" :title="$t('public.tbopt_edit')"
                    @click="editFn(row)"> </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ['loading', 'tableData', 'activeUserType'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)',
            // 状态 icon 映射（与 UAM Account 一致）
            statusIconMap: {
                1: { icon: 'el-icon-circle-check', color: '#67c23a' },
                0: { icon: 'el-icon-circle-close', color: '#f56c6c' },
                2: { icon: 'el-icon-time', color: '#e6a23c' },
                3: { icon: 'el-icon-lock', color: '#909399' }
            },
            statusLabelMap: {
                1: 'account_redesign.enable',
                0: 'account_redesign.disable',
                2: 'account_redesign.pending',
                3: 'account_redesign.expire'
            }
        };
    },
    methods: {
        /** 根据 status 返回 icon 和颜色 */
        getStatusIcon(status) {
            return this.statusIconMap[status] || { icon: 'el-icon-circle-close', color: '#f56c6c' };
        },
        /** 根据 status 返回 label 文案 */
        getStatusLabel(status) {
            const key = this.statusLabelMap[status];
            return key ? this.$t(key) : '';
        },
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg);
            this.$emit('handleSelectionChange', arg);
        },
        editFn(row) {
            this.$emit('editFn', row);
        },
        againFn(row) {
            this.$emit('againFn', row);
        }
    }
};
</script>

<style></style>
